import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import AccommodationService from '@/services/AccommodationService';
import { extractError } from '@/helpers/api';
import { types, actions } from './reducer';

function* viewAccommodation({ id }) {
    try {
        const [
            accommodationData,
            roomTypes,
            offers,
        ] = yield all([
            call(AccommodationService.getOne, id),
            call(AccommodationService.getRoomTypeList, id),
            call(AccommodationService.getAccommodationOffers, id),
        ]);
        const { room_types: roomTypeList } = roomTypes.data;
        yield put(actions.viewAccommodationSucceeded(
            accommodationData.data,
            roomTypeList,
            offers.data,
        ));
    } catch (error) {
        yield put(actions.viewAccommodationFailed(extractError(error)));
    }
}

function* fetchAccommodationRooms({ id, filters, isFetchingMore }) {
    if (isFetchingMore) {
        yield put(actions.fetchMoreAccommodationRooms());
    }
    try {
        const response = yield call(AccommodationService.getReservationList, id, filters);
        if (isFetchingMore) {
            yield put(
                actions.fetchMoreAccommodationRoomsSucceeded(response.data),
            );
            return;
        }
        yield put(actions.fetchAccommodationRoomsSucceeded(response.data));
        localStorage.setItem('accommodationRooms', JSON.stringify(response.data));
    } catch (error) {
        if (isFetchingMore) {
            yield put(actions.fetchMoreAccommodationRoomsFailed(extractError(error)));
            return;
        }
        yield put(actions.fetchAccommodationRoomsFailed(extractError(error)));
    }
}

function* submitAccommodationOffer({ data }) {
    try {
        const response = yield call(AccommodationService.addAccommodationOffer, data);
        yield put(actions.submitAccommodationOfferSucceeded(response.data, 'The offer has been added successfully'));
    } catch (error) {
        yield put(actions.submitAccommodationOfferFailed(extractError(error)));
    }
}

function* viewAccommodationOffer({ id }) {
    try {
        const response = yield call(AccommodationService.viewAccommodationOffer, id);
        yield put(actions.viewAccommodationOfferSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewAccommodationOfferFailed(extractError(error)));
    }
}

function* deleteAccommodationOffer({ id }) {
    try {
        yield call(AccommodationService.deleteAccommodationOffer, id);
        yield put(actions.deleteAccommodationOfferSucceeded(id, 'The offer has been deleted successfully'));
    } catch (error) {
        yield put(actions.deleteAccommodationOfferFailed(extractError(error)));
    }
}

function* watchViewAccommodation() {
    yield takeEvery(
        types.REQUEST_VIEW_ACCOMMODATION,
        viewAccommodation,
    );
}

function* watchFetchAccommodationRooms() {
    yield takeEvery(
        types.REQUEST_FETCH_ACCOMMODATION_ROOMS,
        fetchAccommodationRooms,
    );
}

function* watchSubmitAccommodationOffer() {
    yield takeEvery(
        types.REQUEST_SUBMIT_ACCOMMODATION_OFFER,
        submitAccommodationOffer,
    );
}

function* watchViewAccommodationOffer() {
    yield takeEvery(
        types.REQUEST_VIEW_ACCOMMODATION_OFFER,
        viewAccommodationOffer,
    );
}

function* watchDeleteAccommodationOffer() {
    yield takeEvery(
        types.REQUEST_DELETE_ACCOMMODATION_OFFER,
        deleteAccommodationOffer,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewAccommodation),
        fork(watchFetchAccommodationRooms),
        fork(watchSubmitAccommodationOffer),
        fork(watchViewAccommodationOffer),
        fork(watchDeleteAccommodationOffer),
    ]);
}

export default viewSaga;
